module.exports = __webpack_public_path__ + "static/3-3-40f7456b383aade4d11412c2bb9d8b9d.png";